import React from 'react';
import {
  ChatLines,
  DoubleCheck,
  HexagonDice,
  Lock,
  // MessageText, // Jun-16 (P4): unused after hiding the AI Message template tab
  Trash,
  UnionHorizAlt,
  User,
  UserStar,
  Clock,
  CheckCircle,
  Compass,
} from 'iconoir-react';

export const passwordErrorMessages = {
  CONTAIN_NAME: 'contain',
  ALPHANUMERIC: 'alphanumeric',
  CHARACTERS: 'characters',
  WEAK: 'Password is too weak',
};

export const sliderData = [
  {
    title: 'Seamless Matches',
    description:
      'Discover connections that matter, without the endless searching.',
  },
  {
    title: '"Your AI, your story, summarized."',
    description:
      'We turn your answers into a clear, shareable profile so your agent represents you exactly the way you want.',
  },
  {
    title: '"Behind the scenes, your AI is working for you."',
    description:
      'While you focus on what matters, your agent is out there talking, learning, and finding the right people for you.',
  },
];

export const onboardingDetails = {
  gender: {
    placeholder: 'What is your gender?',
    helperText:
      'Once you have selected your gender, please click the arrow to submit your response.',
  },
  age: {
    placeholder: 'eg. 25',
    helperText: 'Specify your age (in years)',
  },
  resume_linkedin_bio: {
    placeholder: 'Please select any option or all available options',
    helperText: 'Please click the arrow to submit your answer.',
  },
  resume: {
    placeholder: 'Attach your Resume',
    helperText: 'Accepted file types PDF, DOCX (5MB max)',
  },
  linkedin_profile_link: {
    placeholder: 'Share your LinkedIn profile URL',
    helperText: 'Please enter a valid LinkedIn profile URL',
  },
  brief_professional_background: {
    placeholder: 'Write your brief professional background',
    helperText:
      'Briefly present your professional background within 1000 words',
  },
  elevator_pitch: {
    placeholder: 'Write your elevator pitch',
    helperText: 'Keep your elevator pitch within 500 words.',
  },
  core_strength_1: {
    placeholder: 'Enter your first core strength',
    helperText: 'Keep it brief and focused',
  },
  core_strength_2: {
    placeholder: 'Enter your second core strength',
    helperText: 'Keep it brief and focused',
  },
  core_strength_3: {
    placeholder: 'Enter your third core strength',
    helperText: 'Keep it brief and focused',
  },
  primary_goal: {
    placeholder: 'Select one primary goal',
    helperText: 'Click the arrow to submit your answer.',
  },
  connection_funding_stage: {
    placeholder: 'Kindly specify your current funding stage.',
    helperText:
      'Could you kindly provide us with the current funding stage in USD?',
  },
  target_check_size: {
    placeholder: 'Specify your target check size',
    helperText: 'Please enter the target check size.',
  },
  key_metrics: {
    placeholder:
      'Kindly provide the key metrics that you wish to present to our aligned investors.',
    helperText:
      'These are important metrics help our ai model to align your requirements.',
  },
  stage_preference: {
    placeholder: 'Select your preferred stage',
    helperText: 'Click the arrow to submit your answer.',
  },
  industry_focus_areas: {
    placeholder: 'Select key industry focus areas',
    helperText: 'Click the arrow to submit your answer.',
  },
  ideal_customer_profile: {
    placeholder: 'Describe your ideal customer profile (ICP)',
    helperText:
      'Share information about your target audience for your ideal profile.',
  },
  buying_signals: {
    placeholder: 'Describe signals of budget, authority, and need',
    helperText:
      'Identify key signs that show a prospect is ready and qualified to purchase',
  },
  skills_to_learn: {
    placeholder:
      'Please provide a brief overview of the skills you aspire to acquire.',
    helperText: 'Write about new skills would you like to cultivate.',
  },
  career_hurdles: {
    placeholder: 'Enter hurdles you aim to overcome',
    helperText: 'Share a short overview of your current professional hurdles.',
  },
  mentorship_areas: {
    placeholder: 'Please specify the areas in which you provide mentorship.',
    helperText: 'Domains in which you offer mentorship.',
  },
  ideal_mentees: {
    placeholder: 'Enter the type of mentees you’re suited to guide',
    helperText:
      'e.g., Early-stage entrepreneurs, Marketing professionals, Tech students, Career switchers',
  },
  partnership_type: {
    placeholder: 'Enter your preferred type of collaboration',
    helperText: 'Describe the collaboration that would benefit you most.',
  },
  ideal_partner_profile: {
    placeholder: 'Enter a brief profile of your ideal partner',
    helperText: 'Summarize the qualities you seek in a partner.',
  },

  role_title_responsibilities: {
    placeholder: 'Enter the position title and key responsibilities',
    helperText:
      'e.g. Marketing Manager responsible for campaign strategy and team leadership',
  },
  key_qualifications: {
    placeholder: 'Enter the key qualifications required',
    helperText: 'e.g. Proven leadership experience in fast growing teams',
  },
  culture_values: {
    placeholder: 'Enter your preferred workplace culture and values',
    helperText: 'e.g. Innovation driven culture with focus on growth',
  },
  topics_exploring: {
    placeholder: 'Enter the topics you’re exploring',
    helperText:
      'e.g. Artificial Intelligence, Leadership Development, Digital Marketing, Sustainability, Entrepreneurship',
  },
  learning_style: {
    placeholder: 'Enter your preferred learning style',
    helperText: 'e.g Podcasts, short articles, deep dives, mentorship',
  },
  preferred_roles_titles: {
    placeholder: 'Preferred roles/ titles? (comma separated)',
    helperText:
      'Specify relevant fields and positions (list multiple job roles separated by commas).',
  },
  industries_of_interest: {
    placeholder: 'Industries of Interest (comma separated)',
    helperText:
      'Write down names of industries you are interested in with comma separation',
  },
  funding_stage: {
    placeholder: 'Please provide a concise overview of the funding stage.',
    helperText:
      'Provide your company’s funding stage for better context (e.g., Seed, Series A).',
  },
  deal_breakers: {
    placeholder: 'Please outline your non-negotiable criteria.(comma seprated)',
    helperText:
      'List your main deal breakers to help filter out unsuitable connections.',
  },
  preferred_introduction_method: {
    placeholder: '',
    helperText: '',
  },
  introduction_pacing: {
    placeholder: 'What is your preferred volume of introductions?',
    helperText:
      'The selected option will be displayed in the text field. Please click the arrow to submit your answer.',
  },
  communication_style: {
    placeholder: 'Select communication style you prefer',
    helperText:
      'The selected option will be displayed in the text field. Please click the arrow to submit your answer.',
  },
  anything_else: {
    placeholder: 'Share anything else',
    helperText: 'Enter other information you’d like to share',
  },
};

export const settingsTabs = [
  {
    label: 'Personal information',
    value: 'personal-information',
    icon: <User className='w-6 h-6' />,
  },
  // Jun-16 (a user V1 test, P4): hidden. The "AI Message template" feeds the
  // AI-to-AI chat initiation (aiChatService.initiateAiChat injects it as
  // payload.template), and AI-to-AI was decided out of scope. Re-add this entry
  // (and the MessageText import above) to restore it.
  // {
  //   label: 'AI Message template',
  //   value: 'message-template',
  //   icon: <MessageText className='w-6 h-6' />,
  // },
  {
    label: 'AI summary',
    value: 'ai-summary',
    icon: <HexagonDice className='w-6 h-6' />,
  },
  {
    label: 'Update password',
    value: 'update-password',
    icon: <Lock className='w-6 h-6' />,
  },
  {
    label: 'Product tour',
    value: 'product-tour',
    icon: <Compass className='w-6 h-6' />,
  },
  // Apr-20: Delete account — Apple 5.1.1(v) Google Play
  // account-deletion policy compliance. Google Data Safety form's
  // data-deletion URL points here: /settings?tab=delete-account
  {
    label: 'Delete account',
    value: 'delete-account',
    icon: <Trash className='w-6 h-6' />,
  },
];

// Apr-25: dashboard stat cards now carry `info` tooltip strings so
// users understand what each metric means and how it's computed. Copy is
// grounded in the backend's actual aggregations (reciprocity-backend
// dashboard.service.ts::quickStats) — not guessed. Title ≤ 40 chars, body
// ≤ 240 chars per tooltip conventions.
export const dashboardCards = [
  {
    title: 'Pending review',
    icon: <Clock className='sm:min-w-12 sm:w-12 sm:h-12 h-8 w-8' />,
    value: 0,
    isPercentage: false,
    info:
      "Matches waiting for your decision. Counts pending matches where you haven't yet tapped Approve or Pass. Updates as new matches arrive daily.",
  },
  {
    title: 'Connections',
    icon: <CheckCircle className='sm:min-w-12 sm:w-12 sm:h-12 h-8 w-8' />,
    value: 0,
    isPercentage: false,
    info:
      "Mutual approvals: both you and the other person tapped Approve. Once mutual, you can start a conversation.",
  },
  {
    title: 'Conversations',
    icon: <ChatLines className='sm:min-w-12 sm:w-12 sm:h-12 h-8 w-8' />,
    value: 0,
    isPercentage: false,
    info:
      "Active message threads with your Connections where one of you has started messaging.",
  },
  {
    title: 'High compatibility',
    icon: <UserStar className='sm:min-w-12 sm:w-12 sm:h-12 h-8 w-8' />,
    value: 0,
    isPercentage: false,
    info:
      "Matches in the Perfect or Strong tier (score ≥ 70), the system's top-quality recommendations for you.",
  },
];

// Apr-25: also added info tooltips here. Renamed "Match approval rate"
// to "Response rate" — the backend field is `response_rate` and computes
// decisions made (approve OR pass), not approvals specifically. Old label
// was misleading about what the number represents.
export const aiMatchAnalytics = [
  {
    title: 'Average match score',
    percentage: 50,
    info:
      "The average strength of your matches, on a 0 to 100 scale. Your strongest individual matches can score much higher than this average.",
  },
  {
    title: 'Response rate',
    percentage: 0,
    info:
      "Percentage of your matches where you've made a decision: either Approve or Pass. Measures how actively you're reviewing the queue.",
  },
  {
    title: 'Connection rate',
    percentage: 0,
    info:
      "Of the matches you've approved, the percentage that turned into an active conversation. Measures how often approvals lead to real outreach.",
  },
];

export const onboardingSuccessMessages = [
  {
    title: 'Your professional identity & foundation',
    message:
      "Awesome! We've captured your professional identity. Let's keep going and shape your next goals!",
  },
  {
    title: 'Your Core Objectives',
    message:
      'Nice work! Your core objectives are all set. Ready to define what you want to achieve next?',
  },
  {
    title: 'Defining Your Ideal Connections',
    message:
      "Great! We've noted your ideal connections. Let's move forward to strengthen your network goals!",
  },
  {
    title: 'Your Networking Style & Preferences',
    message:
      "Excellent! Your networking style and preferences are now set. Let's see what comes next!",
  },
  {
    title: 'Your extra information',
    message:
      "Perfect! We've captured the final details. You're all set to complete your onboarding journey!",
  },
];

export const aiLoaderMainSentence = 'Preparing your AI summary…';

export const aiLoaderSentences = [
  'Sit tight, we’re getting things ready. No coffee breaks, promise.',
  'Just pulling everything together… it’s like assembling IKEA furniture, but easier.',
  'Putting your summary together, no robots were harmed.',
  'Piecing everything together, kind of like a puzzle… but with fewer missing pieces.',
  'Wrapping up the final bits, adding the secret sauce.',
];
